export const getPmStatus = (equipment) => {
  if (!equipment.lastPmDate || !equipment.pmFrequencyDays) return null;

  const nextDate = new Date(equipment.lastPmDate);
  nextDate.setDate(nextDate.getDate() + Number(equipment.pmFrequencyDays));

  const today = new Date();
  const diffDays = Math.ceil((nextDate - today) / (1000 * 60 * 60 * 24));

  return {
    nextDate,
    diffDays,
    overdue: diffDays < 0,
    dueSoon: diffDays >= 0 && diffDays <= 30,
  };
};

export const getNextPmDate = (lastPmDate, pmFrequencyDays) => {
  if (!lastPmDate || !pmFrequencyDays) return "-";

  const nextDate = new Date(lastPmDate);
  nextDate.setDate(nextDate.getDate() + Number(pmFrequencyDays));

  return nextDate.toLocaleDateString();
};
